import { Box, Button, Checkbox, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { buttonStyle, errorTextStyle, tableHeaderCellStyle } from '../../utils/commonCSS'
import './ChapterLeadsTable.css'
import { amber, green, headingBlue, mediumGrey, orange, pureWhite, red, yellowish } from '../../assets/colors'
import { CheckBox, KeyboardArrowLeft, KeyboardArrowRight, TransferWithinAStation } from '@mui/icons-material'
import CustomDropDown from '../CustomDropDown'
import CustomTextField from '../CustomTextField'
import { tableOffsets } from '../../utils/constants'
import TransferLead from '../TransferLead/TransferLead'
import ClosedLeadDetails from './ClosedLeadDetails'

const ChapterLeadsTable = (props) => {
    const [transferLeadDialogStatus, setTransferLeadDialogStatus] = useState(false)

    const [transferLeadData, setTransferLeadData] = useState([])

    const [detailsDialogStatus , setDetailDialogStatus] = useState(false)
    const [dialogData, setDialogData] = useState({})
    const [isAdvancedTransfer, setIsAdvancedTransfer] = useState(false)
    const [isAllSelected, setIsAllSelected] = useState(false)

    const updateTransferLeadDialog = (refresh = false) => {
        console.log("Reached here with Refresh as: ", refresh)
        setTransferLeadDialogStatus(!transferLeadDialogStatus)
        if(refresh){
            props.updateRefresh()
        }
    }

    const updateDetailsDialogStatus = (value) => {
        setDetailDialogStatus(value)
    }

    var headerCellStyle= {
        padding: '0.3rem 0.5rem 0.3rem 0.5rem',
        fontSize: '1rem',
        textAlign: 'center',
    }

    useEffect(() => {
        setTransferLeadData(() => [])
        setIsAllSelected(() => false)
    }, [props?.data?.records])

  return (
    <>
        <Box className='outerBoxStyle'>
            <Paper className='paperStyle'>
                <Box className='headerBoxStyle'>
                    <Box className='internalBoxStyle'>
                        <Typography  style={{fontSize: '1.1rem', fontWeight: 500, margin: '0rem 0.2rem 0rem 0.2rem'}}>Leads</Typography>
                        <Checkbox style={{padding: '0rem 0.1rem 0rem 0.5rem'}}
                            checked={props.isSMP}
                            onChange={() => props.updateSMPStatus()}
                        ></Checkbox>
                        <Typography>SMP</Typography>
                        <Checkbox style={{padding: '0rem 0.1rem 0rem 0.5rem'}}
                            checked={props.isCaller}
                            onChange={() => {props.updateCallerStatus()}}
                        ></Checkbox>
                        <Typography>Caller</Typography>
                    </Box>
                    <Box style={{ display:'flex', flex: "1 1", width: "80%", justifyContent: 'flex-end', padding: "0rem 0.5rem 0rem 0.5rem", flexWrap: 'wrap', gap: '0.5rem'}}>
                        <CustomTextField 
                            placeHolder="Search Leads..." 
                            value={props.searchValue} 
                            setFunc={props.updateSearchValue} 
                        />
                        <Button variant='outlined' sx={{...buttonStyle, pointerEvents: transferLeadData?.length > 0 ? 'auto': 'none', backgroundColor: transferLeadData?.length > 0 ? headingBlue: mediumGrey}}

                            onClick={() => {
                                setTransferLeadDialogStatus(true)
                            }}
                        >
                            Bulk Transfer
                        </Button>
                        <Button variant='outlined' sx={{...buttonStyle}}
                            onClick={() => {
                                setTransferLeadData([])
                                setIsAdvancedTransfer(true)
                                setTransferLeadDialogStatus(true)
                            }}
                        >
                            Advanced Transfer
                        </Button>
                        

                    </Box>

                </Box>
                <Box className='tableOuterBoxStyle'>
                    <TableContainer component={Paper} className='tableContainerStyle'>
                        <Table stickyHeader>
                            <TableHead style={{backgroundColor: mediumGrey}}>
                                <TableRow>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        <Checkbox
                                            checked={isAllSelected}
                                            onChange={() => {
                                                if( isAllSelected){
                                                    setTransferLeadData(() => [])
                                                    setIsAllSelected(() => false)
                                                } else {
                                                    props?.data?.records?.map((row) => {
                                                        setTransferLeadData(prev => [...prev, row?.contactNumber])
                                                    })
                                                    setIsAllSelected(() => true)
                                                }

                                            }}
                                        ></Checkbox>
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Lead Name & Contact
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Phone Name
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Age & Gender
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        District & State
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Template 
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Assigned To
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Lead Status
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Lead Response
                                    </TableCell>
                                    <TableCell style={{...headerCellStyle, backgroundColor: "#D9D9D9"}}>
                                        Actions
                                    </TableCell>
                                </TableRow>

                            </TableHead>
                            <TableBody>
                                {
                                    props?.data?.records?.length > 0 ?
                                        props?.data?.records?.map((row, index) => {
                                        return(
                                            <TableRow key={index}>
                                                <TableCell className = 'headerCellStyle'>
                                                    <Checkbox 
                                                        checked={transferLeadData?.includes(row.contactNumber)}
                                                        onChange={() => {
                                                            if(transferLeadData?.includes(row?.contactNumber)){
                                                                setTransferLeadData(prev => prev.filter(item => item != row.contactNumber))
                                                                if( transferLeadData?.length === props?.data?.records?.length){
                                                                    setIsAllSelected(() => false)
                                                                }
                                                            } else {
                                                                setTransferLeadData(prev => [...prev, row?.contactNumber])
                                                                if(transferLeadData?.length === props?.data?.records?.length - 1){
                                                                    setIsAllSelected(() => true)
                                                                }
                                                            }
                                                        }}>
                                                    </Checkbox>
                                                </TableCell>
                                                <TableCell className = 'headerCellStyle'>
                                                    {row.name ? row.name : '-'}<br></br>
                                                    {row.contactNumber ? row.contactNumber : '-'}
                                                </TableCell>
                                                <TableCell className = 'headerCellStyle'>
                                                    {row.phoneName ? row.phoneName : '-'}
                                                </TableCell>
                                                <TableCell  className = 'headerCellStyle'>
                                                    {row.age ? row.age : '-'}<br></br>
                                                    {row.gender ? row.gender : '-'}
                                                </TableCell>
                                                <TableCell  className = 'headerCellStyle'>
                                                    {row.district ? row.district : '-'}<br></br>
                                                    {row.chapter ? row.chapter : '-'}
                                                </TableCell>
                                                <TableCell  className = 'headerCellStyle'>
                                                    {row.templateName ?  row.templateName : '-' }
                                                </TableCell>
                                                <TableCell  className = 'headerCellStyle'>
                                                    {row.isAssignedToChapterCaller ?  row.assignedToWORKer : row.isAssignedToCaller ? row.assignedTo : row?.smpAssigned} <br></br>
                                                    {row.WORKerName ?  row.WORKerName : row?.smpAssignedCN }
                                                </TableCell>
                                                    {
                                                        row.leadStatus ?
                                                        (
                                                            row.leadStatus === 'followUp' ?
                                                            <TableCell  style={{...tableHeaderCellStyle, color: yellowish, fontSize: '0.8rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}
                                                                onClick={() => {
                                                                    updateDetailsDialogStatus(true)
                                                                    setDialogData(row)
                                                                }}
                                                            >
                                                                Follow Up
                                                            </TableCell> :
                                                            row.leadStatus === 'wrongNumber' ?
                                                            <TableCell  style={{...tableHeaderCellStyle, color: red, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Wrong Number
                                                            </TableCell>:
                                                            row.leadStatus === 'notReachable' ?
                                                            <TableCell  style={{...tableHeaderCellStyle, color: orange, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Not Reachable
                                                            </TableCell>:
                                                            row.leadStatus === 'closed' ?
                                                            <TableCell  style={{...tableHeaderCellStyle, color: green, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}
                                                                onClick={() => {
                                                                    updateDetailsDialogStatus(true)
                                                                    setDialogData(row)
                                                                }}
                                                            >
                                                                Closed
                                                            </TableCell>:
                                                            <TableCell  style={{...tableHeaderCellStyle, color: headingBlue, fontSize: '0.8rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                {row.leadStatus ? row.leadStatus : 'Not Yet Initiated'}<br></br>
                                                            </TableCell> 
                                                        )
                                                        :
                                                        <TableCell  style={{...tableHeaderCellStyle, color: headingBlue, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                            Not Initiated
                                                        </TableCell>
                                                    }

                                                    {
                                                        row.leadResponse ? (
                                                            row.leadResponse === 1 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: red, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Anti Allama
                                                            </TableCell> :
                                                            row.leadResponse === 2 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: red, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Time Waste
                                                            </TableCell> :
                                                            row.leadResponse === 3 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: amber, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Not Interested Now
                                                            </TableCell> :
                                                            row.leadResponse === 4 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: amber, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Low Response
                                                            </TableCell> :
                                                            row.leadResponse === 5 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: amber, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Interested In Knowledge
                                                            </TableCell> :
                                                            row.leadResponse === 6 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: green, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                Potential WORKer
                                                            </TableCell> :
                                                            row.leadResponse === 7 ?
                                                            <TableCell style={{...tableHeaderCellStyle, color: green, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                VIP Contact
                                                            </TableCell> :
                                                            
                                                            <TableCell style={{...tableHeaderCellStyle, color: green, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                                {row.leadResponse ? row.leadResponse : '-'}
                                                            </TableCell>
                                                        ): 
                                                        <TableCell style={{...tableHeaderCellStyle, color: green, fontSize: '0.85rem', textShadow: `0.1rem 0.1rem 0.07rem ${mediumGrey}`}}>
                                                            {row.leadResponse ? row.leadResponse : '-'}
                                                        </TableCell>
                                                    }
                                                <TableCell style={{...tableHeaderCellStyle}}>
                                                        <TransferWithinAStation 
                                                            style={{color: headingBlue,}}
                                                            onClick={() => 
                                                                {
                                                                    setTransferLeadData(() => [])
                                                                    setTransferLeadData(prev => [...prev, row.contactNumber])
                                                                    setIsAdvancedTransfer(false)
                                                                    setTransferLeadDialogStatus(true)
                                                                }
                                                            }
                                                        ></TransferWithinAStation>
                                                </TableCell>
                                                    
                                                    

                                            </TableRow>
                                        )
                                    }) :
                                    <Typography style={{...errorTextStyle}}>{props.apiError}</Typography>
                            }
                            </TableBody>

                        </Table>

                    </TableContainer>
                </Box>
                <Box className='tableFooterOuterBox'>
                    <Box className='tableFooterInnerBox1'>
                        <Typography className='tableFooterCountTypography'>
                            {((props?.pageValue - 1) * props?.offsetValue) +1} - {(props?.pageValue * props?.offsetValue) < (props?.data?.totalRecords) ? (props?.pageValue * props?.offsetValue) : props?.data?.totalRecords} of {props?.data?.totalRecords} 
                        </Typography>
                    </Box>
                    <Box className='tableFooterInnerBox2'>
                        <IconButton size='small'
                            onClick= {() => {
                                if( props?.pageValue > 1){
                                    props.updatePage(props?.pageValue - 1)
                                }
                            }}
                            disabled={props.pageValue === 1}
                        >
                            <KeyboardArrowLeft size='small'
                                sx= {{color: props.pageValue === 1 ? mediumGrey: headingBlue}}
                            >
                            </KeyboardArrowLeft>
                        </IconButton>
                        <Button style={{minWidth: '0rem', width: '1.5rem', height: '1.5rem', borderRadius: '50%', backgroundColor: headingBlue, color: pureWhite, padding: '0rem', alignItems: 'center'}}>{props?.pageValue}</Button>
                        <IconButton size='small'
                            onClick={() => {
                                if( props.pageValue < props?.data?.totalPages){
                                    props.updatePage(props.pageValue + 1)
                                }
                            }}
                            disabled={props.pageValue === props?.data?.totalPages}
                        >
                            <KeyboardArrowRight size='small'
                                sx= {{color: (props.pageValue === props?.data?.totalPages || props?.data?.totalPages === 0) ? mediumGrey: headingBlue}}
                            ></KeyboardArrowRight>
                        </IconButton>
                    </Box>
                    <Box className='tableFooterInnerBox3'>
                        <CustomDropDown list={tableOffsets} 
                            value= {props.offsetValue}
                            setFunc={props.updateOffset}
                            width= '5rem' regular={true}></CustomDropDown>
                    </Box>
                </Box>
            </Paper>

        </Box>
        <TransferLead 
            dialogStatus={transferLeadDialogStatus}
            dialogstatusFunc={updateTransferLeadDialog}
            transferLeadData={transferLeadData}
            headDashboard={true}
            isAdvanced={isAdvancedTransfer}
        ></TransferLead>
        <ClosedLeadDetails dialogStatus={detailsDialogStatus} updateDialogStatus={updateDetailsDialogStatus} data={dialogData}></ClosedLeadDetails>
    </>
  )
}

export default ChapterLeadsTable
